<app-page-meta pageTitle="finzy - Loan Application Status"></app-page-meta>
<app-header></app-header>
<div class="container-fluid" *ngIf="loanDetails">
        <div class="row">
        <app-borrower-menu></app-borrower-menu>
            <div class="col-xs-12 col-md-10 col-lg-11">
                <div class="image">
                    <img class="finzy-img" src="../../assets/images/borrower-loan-matured/group-2.png">
                </div>
                <p class="finzy-row1">Your finzy loan is fully repaid and closed!</p>
                <p class="finzy-row2">We hope you had a great finzy experience. Here are the details of your
                    loan</p>
            </div>
            <div class="row flex-container">
                <div>
                <p class="loan-detail">{{loanDetails.generated_loan_id}}</p>
                <p class="loan-header">Loan ID</p>
                </div>
                <div>
                    <p class="loan-detail">₹ {{loanDetails.loan_fulfilled_amount}}</p>
                    <p class="loan-header">Loan amount</p>
                </div>
                <div>
                    <p class="loan-detail">{{loanDetails.loan_tenure}}M</p>
                    <p class="loan-header">Tenure</p>
                </div>
                <div>
                   <p class="loan-detail">{{loanClosureDate}}</p>
                    <p class="loan-header">Loan closure date</p>
                </div>
                <div>
                    <p class="loan-detail">₹ 0.00</p>
                    <p class="loan-header">Principal outstanding</p>
                </div>
            </div>
            <div class="row flex finzy-row3">
                <div>Supporting documents for loan closure will be sent to your registered email id</div>
            </div>
            <div class="row flex finzy-row4">
                <div> If you have any questions / clarifications, call us on <span class="brand-color   ">9341300300</span>. We are always happy to help!</div>
            </div>
        </div>
    </div>
